import React from "react";
import { NoticesAndWarnings } from "./ProductDetailPageResult";
import ProductNoticesAndWarnings from "./ProductNoticesAndWarnings";
interface Props {
  header: string;
  description: string;
  isCommonCarrier: boolean;
  noticesAndWarnings: NoticesAndWarnings;
  isOutletTemplate: boolean;
  outletHighlights?: string;
  showEverlivingProductPage: boolean;
}
const ProductDescription = ({
  header,
  description,
  isCommonCarrier,
  noticesAndWarnings,
  isOutletTemplate,
  outletHighlights = "",
  showEverlivingProductPage
}: Props) => <div id="details-group" className="details" style={{
  scrollMarginTop: "100px"
}} data-sentry-component="ProductDescription" data-sentry-source-file="ProductDescription.tsx">
    <h2 data-testid="product-description-heading">
      {isOutletTemplate && "Scratch and Dent "}
      {header.length > 0 && header} Details
    </h2>
    {outletHighlights?.length > 0 && <div
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: outletHighlights
  }} />}
    {description.length > 0 && <p
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: description
  }} />}
    <ProductNoticesAndWarnings isCommonCarrier={isCommonCarrier} noticesAndWarnings={noticesAndWarnings} showEverlivingProductPage={showEverlivingProductPage} data-sentry-element="ProductNoticesAndWarnings" data-sentry-source-file="ProductDescription.tsx" />
  </div>;
export default ProductDescription;